import { render, staticRenderFns } from "./tipostarea-form.vue?vue&type=template&id=5f31faf5&scoped=true"
import script from "./tipostarea-form.vue?vue&type=script&lang=js"
export * from "./tipostarea-form.vue?vue&type=script&lang=js"
import style0 from "./tipostarea-form.vue?vue&type=style&index=0&id=5f31faf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f31faf5",
  null
  
)

export default component.exports